import MenuIcon from '@mui/icons-material/Menu'
import { Alert, IconButton, Stack } from '@mui/material'
import React, { useContext } from 'react'

import { TABLET_WIDTH_BREAKPOINT } from '../../config/breakPoints'
import { FeatureFlags } from '../../models/FeatureFlags'
import { NavVisibilityContext, WindowSizeContext } from '../../providers'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import { AuthNav } from '../AuthNav'
import { AppHeaderSearchWithAutocomplete } from '../SearchWithAutocomplete'

export const AppHeader: React.FC = () => {
  const { setStayOpen } = useContext(NavVisibilityContext)
  const { width } = useContext(WindowSizeContext)

  const { featureFlags } = useContext(AppContext)
  const isReadOnly = featureFlags && featureFlags[FeatureFlags.ReadOnly]

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={1}
      px={2}
      py={0}>
      {width < TABLET_WIDTH_BREAKPOINT && (
        <IconButton
          data-testid={'ShowNavMenuButton'}
          onClick={() => setStayOpen(true)}>
          <MenuIcon />
        </IconButton>
      )}
      <AppHeaderSearchWithAutocomplete />

      {isReadOnly && (
        <Alert severity="warning" variant="filled">
          READ ONLY
        </Alert>
      )}
      <AuthNav />
    </Stack>
  )
}
